import { MouseEvent } from 'react';

export const getSeekToProgressOnClick = (event: MouseEvent) => {
  const { left, width } = event.currentTarget.getBoundingClientRect();
  const xPosition = event.clientX - left;
  return xPosition / width;
};
